var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "dropdown", staticClass: "multiselect-dropdown" }, [
    _vm.label
      ? _c(
          "label",
          { staticClass: "multiselect-label", attrs: { for: _vm.name } },
          [_vm._v(_vm._s(_vm.label))]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        class: ["multiselect-control", { "has-error": _vm.validationError }],
        on: { click: _vm.toggleDropdown },
      },
      [
        _c(
          "div",
          { staticClass: "selected-items" },
          [
            _vm.selectedItems.length
              ? [
                  _vm._l(_vm.visibleSelected, function (item, idx) {
                    return _c(
                      "div",
                      {
                        key: item.id || idx,
                        staticClass: "selected-item",
                        attrs: { title: _vm.getLabel(item) },
                      },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.getLabel(item)))]),
                        _vm._v(" "),
                        _vm.multiple
                          ? _c(
                              "button",
                              {
                                staticClass: "remove-item",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.removeSelected(item)
                                  },
                                },
                              },
                              [_c("i", { staticClass: "fas fa-times" })]
                            )
                          : _vm._e(),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.multiple && _vm.restCount > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "selected-item more",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              _vm.dropdownOpen = true
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            +" +
                              _vm._s(_vm.restCount) +
                              "\n          "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              : _c("h5", { staticClass: "placeholder" }, [
                  _vm._v(_vm._s(_vm.label)),
                ]),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "toggle-button", attrs: { type: "button" } },
          [
            _c("i", {
              class: _vm.dropdownOpen ? "fas fa-angle-up" : "fas fa-angle-down",
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _vm.validationError
      ? _c("span", { staticClass: "error-message" }, [
          _vm._v(_vm._s(_vm.validationError)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.dropdownOpen,
            expression: "dropdownOpen",
          },
        ],
        staticClass: "dropdown-options",
        on: { scroll: _vm.onScroll },
      },
      [
        _c("div", { staticClass: "search-wrap" }, [
          _c("i", { staticClass: "fas fa-search" }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchQuery,
                expression: "searchQuery",
              },
            ],
            attrs: {
              type: "text",
              placeholder: _vm.Lang.get("messages.search"),
            },
            domProps: { value: _vm.searchQuery },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.searchQuery = $event.target.value
                },
                _vm.resetVisibleCount,
              ],
            },
          }),
        ]),
        _vm._v(" "),
        _vm._l(_vm.filteredOptions, function (option) {
          return _c("li", { key: option.id || option[_vm.labelField] }, [
            _vm.multiple
              ? _c("input", {
                  attrs: {
                    type: "checkbox",
                    id: "option" + (option.id ?? _vm.getLabel(option)),
                  },
                  domProps: { checked: _vm.isSelected(option) },
                  on: {
                    change: function ($event) {
                      return _vm.toggleOption(option)
                    },
                  },
                })
              : _c("input", {
                  attrs: {
                    type: "radio",
                    name: "single-select",
                    id: "option" + (option.id ?? _vm.getLabel(option)),
                  },
                  domProps: { checked: _vm.isSelected(option) },
                  on: {
                    change: function ($event) {
                      return _vm.toggleOption(option)
                    },
                  },
                }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "option-label",
                attrs: { for: "option" + (option.id ?? _vm.getLabel(option)) },
              },
              [_vm._v(_vm._s(_vm.getLabel(option)))]
            ),
          ])
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }